import {IDataModel} from "../../services/IDataModel";
import {Http, URLSearchParams, RequestOptions} from "@angular/http";
import {IDataFilter} from "../../services/DataTable";
import * as _ from "lodash";
import {Observable} from "rxjs/Rx";
import {ResponseModel, ListResponseModel} from "../response/response.model";
import {Injectable} from "@angular/core";
import {NotificationsModel, NotificationsUnreadCountsModel} from "./notifications.model";
import EventEmitter = NodeJS.EventEmitter;

@Injectable()
export class NotificationsService implements IDataModel {

    private API_ROOT:string = '/notifications';

    constructor(
        private http:Http
    ) {


    }

    getList(filter:IDataFilter): Observable<ListResponseModel<NotificationsModel>>  {
        let params:URLSearchParams = new URLSearchParams();
        for (let key in filter) {
            params.set(key, filter[key]);
        }
        return this.http
            .get(this.API_ROOT, new RequestOptions({
                search: params
            }))
            .map(r => r.json());
    }

    getOne(id:number):Observable<ResponseModel<NotificationsModel>> {
        return this.http.get(`${this.API_ROOT}/${id}`).map((res) => res.json());
    }

    add(fields:NotificationsModel): Observable<ResponseModel<NotificationsModel>>  {
        return this.http.post(this.API_ROOT, fields).map((res) => res.json());
    }

    edit(id:number, fields:NotificationsModel): Observable<ResponseModel<NotificationsModel>>  {
        return this.http.put(`${this.API_ROOT}/${id}`, fields).map((res) => res.json());
    }

    remove(id:number) {
        return this.http.delete(`${this.API_ROOT}/${id}`).map((res) => res.json());
    }

}


// WEBPACK FOOTER //
// ./src/app/models/notifications/notifications.service.ts